import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';
import { AttributeDefinitionFormData } from '@src/app/shared/components/attribute-definition-form/attribute-definition.model';
import { RetailerAttributeDefinitionsAdapter } from '../retailer-attribute-definitions.adapter';

@Component({
  selector: 'app-edit-retailer-attribute-definitions',
  templateUrl: './edit-retailer-attribute-definitions.component.html',
  styleUrl: './edit-retailer-attribute-definitions.component.scss',
  host: {
    class: 'app-edit-retailer-attribute-definitions'
  },
  standalone: false
})
export class EditRetailerAttributeDefinitionsComponent extends BaseViewComponent implements OnInit {
  retailerAttributeDefinitionId = 0;
  retailerAttributesDefinitions: AttributeDefinitionFormData | undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private retailerAttributeDefinitionsAdapter: RetailerAttributeDefinitionsAdapter
  ) {
    super();
  }

  ngOnInit(): void {
    this.route.params.subscribe(async params => {
      this.retailerAttributeDefinitionId = Number(params['retailerAttributeDefinitionId']);

      if (this.retailerAttributeDefinitionId > 0) {
        await this.get();
      }
    });
  }

  override async get(): Promise<void> {
    this.retailerAttributesDefinitions = await this.retailerAttributeDefinitionsAdapter.get(
      this.retailerAttributeDefinitionId
    );
  }

  async submitForm(definition: AttributeDefinitionFormData): Promise<void> {
    await this.retailerAttributeDefinitionsAdapter.update(this.retailerAttributeDefinitionId, definition);
    this.router.navigate([`/retailer-attribute-definitions/${this.retailerAttributeDefinitionId}`]);
  }
}
